export const getProjectSiteViewUrl = (
  projectId: number | string,
  projectSiteId: number | string
): string => `/projects/${projectId}/project_sites/${projectSiteId}/view`;
